import React, { useRef, useState } from "react";
import { Form, Input, Button, message, Space } from "antd";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";


const TryForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const formData = useRef(null);
  const [Loading, setLoading] = useState(false);

  const isValid = useRef(false)

  const onFinish = (values) => {
    formData.current = values;
    isValid.current = true

    if (isValid.current) {
      setLoading(true)
      fetch("http://moyuanfang.cn:9090/myf/postApplication", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData.current, (key, value) => {
          if (key === 'agreement') {
            return undefined
          }
          return value
        }),
      })
        .then(() => {
          message.success("提交成功")
        })
        .catch((error) => {
          message.error('提交失败，请检查网络或提交信息是否正常')
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onFinishFailed = () => {
    isValid.current = false
  }

  const reset = () => {
    form.resetFields();
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h5 className="text-2xl font-semibold">墨圆方企业试用版申请</h5>
      </div>
      <div className={styles.form}>
        <Form
          form={form}
          layout="vertical"
          style={{
            width: 360
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="单位"
            name="organization"
            rules={[
              {
                required: true,
                message: "请输入单位名称",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Space size='large'>
            <Form.Item
              label="行业"
              name="industry"
              rules={[
                {
                  required: true,
                  message: "请输入公司行业",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="规模"
              name="size"
              rules={[
                {
                  required: true,
                  message: "请输入公司规模",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Space>
          <Space size='large'>
            <Form.Item
              label="联系人姓名"
              name="name"
              rules={[
                {
                  required: true,
                  message: "请输入联系人姓名",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="联系人职务"
              name="job"
              rules={[
                {
                  required: true,
                  message: "请输入联系人职务",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Space>
          <Space size='large'>
            <Form.Item
              label="联系电话"
              name="phone"
              rules={[
                {
                  required: true,
                  message: "请输入联系电话",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="电子邮箱"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "请输入有效邮箱",
                },
                {
                  required: true,
                  message: "请输入电子邮箱",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Space>
          <Form.Item
            label="CAD平台"
            name="cadPlatform"
            rules={[
              {
                required: true,
                message: "请输入CAD平台",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="CAD版本"
            name="cadVersion"
            rules={[
              {
                required: true,
                message: "请输入CAD版本",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="申请试用目的"
            name="purposes"
            rules={[
              {
                required: true,
                message: "请输入申请试用目的",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button
              className="bg-blue-600 transition-all duration-300"
              type="primary"
              htmlType="submit"
              loading={Loading}
            >
              提交
            </Button>
            <Button
              className="ml-4"
              danger
              htmlType="button"
              onClick={reset}
            >
              重置
            </Button>
            <Button
              className="ml-4 bg-blue-600 text-slate-100"
              htmlType="button"
              onClick={() => navigate(-1)}
            >
              返回上一页
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default TryForm;
